import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from '../../themes/defaultTheme';
import { GilroyFont, ProximaNovaFont } from '../Fonts';
import { CssVariables } from './CssVariables';
const emptyTheme = {};
export const TombacApp = _ref => {
  let {
    children,
    defineCssVariables = false,
    theme = emptyTheme
  } = _ref;
  const [appTheme, setAppTheme] = useState({
    ...defaultTheme,
    ...theme
  });
  useEffect(function updateAppTheme() {
    setAppTheme({
      ...defaultTheme,
      ...theme
    });
  }, [theme]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: appTheme
  }, /*#__PURE__*/React.createElement(GilroyFont, null), /*#__PURE__*/React.createElement(ProximaNovaFont, null), defineCssVariables && /*#__PURE__*/React.createElement(CssVariables, null), children);
};
//# sourceMappingURL=TombacApp.js.map